import { useAuthStore } from "@/src/store"

import { Stack, Select, Divider, MenuItem, Typography } from "@mui/material"

export const WorkspaceOptions = () => {
    const user = useAuthStore((state) => state.user)
    const switchWorkspace = useAuthStore((state) => state.switchWorkspace)

    // const isEditIconAllowed =
    //     user?.activeWorkspace?.roleName === "SUPER_ADMIN" || user?.activeWorkspace?.roleName === "ADMIN"

    const renderWorkspaceTooltip = () => {
        return (
            <Stack spacing={1}>
                <Stack spacing={1} alignItems="center" width="100%" mt="10px">
                    <Select
                        fullWidth
                        value={user?.activeWorkspace?.id}
                        onChange={(e) => {
                            switchWorkspace(e.target.value)
                        }}
                    >
                        {user?.workspaces.map((workspace) => (
                            <MenuItem key={workspace.id} value={workspace.id}>
                                {workspace.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Stack>
            </Stack>
        )
    }
    return renderWorkspaceTooltip()
}
